var ajaxPromise,
	pathArray = location.href.split('/'),
	protocol = pathArray[0],
	host = pathArray[2],
    ajax_url = protocol + '//' + host + '/wp-admin/admin-ajax.php';

function carPark(town, development) {
    $('#loading').addClass('active');
    $('.car-park').addClass('active');

    var result;
    ajaxPromise = $.ajax({
        type: 'POST',
        url: ajax_url,
        dataType: 'json',
        data: ({
            'action': 'ajax_carpark',
            'town': town,
            'development': development
        }),
        success: function (data) {
            result = data.html;  
        }
    });
    $.when(ajaxPromise).done(function () {
        $('.car-park-content').html(result);
        $('#loading').removeClass('active'); 
        $('.car-park').removeClass('active');
    });
}


$(document).on("change", 'select.development', function(e) {
    e.preventDefault(); 
    var town = $('select.town').find(':selected').data('id');
    var development = $(this).find(':selected').data('id');

    carPark(town, development);
});